export type PlannerControlSchema = 'vehicle' | 'next'

export const DEFAULT_PLANNER_CONTROL_SCHEMA: PlannerControlSchema = 'vehicle'

export const CONTROL_DATA_SCHEMA_HEADER = 'city-sense-control-data-schema'

export const NEXT_CONTROL_SCHEMA_NAME = 'control_data_next'

export function planningDataSchemaHeaders(
  schema: PlannerControlSchema
): { [CONTROL_DATA_SCHEMA_HEADER]: string } | undefined {
  return schema === 'next' ? { [CONTROL_DATA_SCHEMA_HEADER]: NEXT_CONTROL_SCHEMA_NAME } : undefined
}

export function shouldConfirmSchemaSwitch(options: {
  fromSchema: PlannerControlSchema
  toSchema: PlannerControlSchema
  hasUnsavedChanges: boolean
  hasEditState: boolean
}): boolean {
  if (options.fromSchema === options.toSchema) return false
  return options.hasUnsavedChanges || options.hasEditState
}
